import apmRoutes from 'routes/routesByRole/pmRoutes';

export default apmRoutes;
